module.exports = __webpack_public_path__ + "img/archived.b3e5ec0a.svg";